import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { type FC } from 'react';

import { Button } from '@/components/Button';

type PublishDraftsConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  draftsWithoutTaskCount: number;
  onConfirmPublish: () => void | Promise<void>;
};

export const PublishDraftsConfirmDialog: FC<PublishDraftsConfirmDialogProps> = ({
  open,
  onClose,
  draftsWithoutTaskCount,
  onConfirmPublish,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ '.MuiPaper-root': { borderRadius: '8px' } }}
    >
      <DialogTitle sx={{ fontFamily: 'Montserrat, sans-serif' }}>
        Часть черновиков будет пропущена
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontFamily: 'Montserrat, sans-serif' }}>
          {draftsWithoutTaskCount} черновиков без задачи не будут опубликованы. Продолжить?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Отмена
        </Button>
        <Button
          variant="contained"
          onClick={async () => {
            await onConfirmPublish();
            onClose();
          }}
        >
          Опубликовать
        </Button>
      </DialogActions>
    </Dialog>
  );
};
